<template>
  <div style="width:100%;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button v-if="inputForm&&inputForm.auditStatus=='1'&&type!='done'&&isTransact" size="small" style="width: 15%;margin-top: 2%;" type="info"
                    @click="show">办理
        </van-button>
        <van-button size="small" style="margin-left: 3%;width: 15%;" type="info" @click="close">返回</van-button>
      </div>

      <div v-if="isshow" class="doTask">
        <div>
          <van-field label="审批意见" name="radio">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" autosize @input="isMessage=false" label="审批说明" placeholder="请输入审批说明" rows="2"
                       type="textarea"/>
          </van-cell-group>
        </div>
        <div v-if="isMessage" style="color: red">请输入审核意见</div>
        <div style="text-align:center">
          <van-button size="small" style="width: 15%;margin-top: 2%;" type="info" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames" style="margin-top: 60px;">
      <van-collapse-item name="1" title="基本信息">
        <van-row>
          <van-col span="24">
            <van-field v-model="conName" autosize label="签订形式" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.name" autosize label="名称" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row v-if="type=='done'">
          <van-col span="24">
            <van-field v-model="inputForm.statesName" autosize label="状态" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row v-if="type=='done'">
          <van-col span="24">
            <van-field v-model="inputForm.auditStatusName" autosize label="审核状态" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.code" autosize label="编码" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="proName" autosize label="项目" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.signingDate" autosize label="签订日期" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.contractEditionName" autosize label="版本" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.partyUnit" autosize label="甲方" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.partyBName" autosize label="乙方" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.signatoryName" autosize label="签订人" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.operatorDeptName" autosize label="签订部门" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.departmentHead" autosize label="部门负责人" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.contractContent" autosize label="摘要" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
      </van-collapse-item>
      <van-collapse-item name="2" title="价款信息">
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.initialContractAmount" autosize label="金额（元）" label-width="100px" readonly
                       rows='1' type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.initialContractAmountBig" autosize label="大写金额" label-width="100px" readonly
                       rows='1' type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-if="inputForm.isContract==0" v-model="inputForm.taxRate" autosize label="税率（%）" label-width="100px" readonly
                       rows='1' type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.serviceAmount" autosize label="服务费（元）" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.materialEquipment" autosize label="设备金额（元）" label-width="100px" readonly
                       rows='1' type="textarea"/>
          </van-col>
        </van-row>
      </van-collapse-item>
      <van-collapse-item name="3" title="其他信息">
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.executorDeptName" autosize label="执行部门" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-if="inputForm.isContract===0" v-model="inputForm.placeOfSigning" autosize label="签订地点"
                       label-width="100px" readonly
                       rows='1' type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-if="inputForm.isContract===0" v-model="inputForm.formationName" autosize label="形成方式"
                       label-width="100px" readonly
                       rows='1' type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-if="inputForm.isContract!=0" v-model="inputForm.countersignApprove" autosize label="会签审批单编号"
                       label-width="100px"
                       readonly rows='1' type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field v-model="inputForm.remarks" autosize label="备注" label-width="100px" readonly rows='1'
                       type="textarea"/>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-field label="物料台账" label-width="100px" readonly>
              <template #button>
                <van-button plain type="default" @click="view">查看物料台账</van-button>
              </template>
            </van-field>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
              <p>附件</p>
              <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file,'mater')">{{file.name}}</p>
            </div>
          </van-col>
        </van-row>
      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import auditService from '@/api/mater/auditService'
import ContractService from '@/api/mater/contractService'
import QueryInfoService from '@/api/system/queryInfoService'
import Vue from "vue";
import processRecord from "../../../components/processRecord/processRecord";

export default {
  data() {
    return {
      activeNames: ['1', '2', '3'],
      isshow: false,
      isMessage: false,
      isTransact:false,
      isLoading:false,
      radio: '',
      msg: '',
      inputForm: {
        id: '',
        projectId: '',
        unit: '',
        remarks: '',
        theme: '',
        attachList: [],
        attachIds: [],
        unitPrices: []
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      flowParam: {},
      certList: [],
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      businessId: '',
      type: ''
    }
  },
  components: {
    processRecord
  },
  computed:{
    proName: function() {
      return `${this.inputForm.projectName} ${this.inputForm.periodizationName?'/'+this.inputForm.periodizationName:''}${this.inputForm.jianAnName?'/'+this.inputForm.jianAnName:''}`;
    },
    conName: function() {
      return `${this.inputForm.isContract=='0'?'合同':'会签'}/${this.inputForm.applyTypeName}`;
    }
  },
  mounted() {
  },
  created() {
    let query = this.$route.query;
    this.businessId = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.isMessage=false
    this.isLoading=false
    // let id = this.$cookie.get('id')
    // this.taskId = this.$cookie.get('taskId')
    // this.taskDefKey = this.$cookie.get('taskDefKey')
    // this.procInsId = this.$cookie.get('procInsId')
    // this.procDefId = this.$cookie.get('procDefId')
    this.init(this.businessId)
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
      this.flowParam = {
        id: this.procInsId,
        businessId: this.businessId,
        approvalStatus: undefined,
        approvalOpinion: undefined,
      };
    },
    init(id) {
      // alert(Vue.cookie.get('mater-userId'))
      new ContractService().getContract(id).then(res => {
        // this.msg = JSON.stringify(res)
        this.inputForm = res.data.data
        // 获取审批人
        let queryParams = {
          businessId: this.businessId,
          flowStatus: this.inputForm.auditStatus == '1' ? '1' : this.inputForm.auditStatus == '2' ? '2' : '0',//流程状态
          moduleFlag:"300"
        }
        new QueryInfoService().listMyFlowprocess(queryParams).then(res => {
          this.isTransact = res.data.rows.map(row => row.approvalId).includes(Vue.cookie.get('mater-userId'))
          // alert(this.isTransact, 'isTransact')
        }).catch(e => {
          console.log(e)
        })
        // 附件转换
        this.inputForm.attachList = this.inputForm.attachments ? JSON.parse(this.inputForm.attachments) : []
        // 大小写转换
        this.inputForm.initialContractAmountBig = this.transferAmount(this.inputForm.initialContractAmount);
        // 保留两位小数
        this.inputForm.initialContractAmount = this.fomatFloat(this.inputForm.initialContractAmount, 2)
        this.inputForm.serviceAmount = this.fomatFloat(this.inputForm.serviceAmount, 2)
        this.inputForm.materialEquipment = this.fomatFloat(this.inputForm.materialEquipment, 2)
        // 获取用户
        new QueryInfoService().getUser(this.inputForm.signatory).then(user => {
          this.$set(this.inputForm, 'signatoryName', user.data.data.nickName);
        }).catch(e => {
          console.log(e)
        })
        // 日期格式化
        const dates = [
          [this.inputForm.signingTime, 'signing'],
        ].map(([userType, formField]) => {
          this.$set(this.inputForm, `${formField}Date`, userType.slice(0,10));
        });
        // 获取项目
        new QueryInfoService().listProject().then(pro => {
          this.$set(this.inputForm, 'projectName', pro.data.data.find(item => item.id == this.inputForm.projectId).name);
        }).catch(e => {
          console.log(e)
        })
        // 获取部门
        const depts = [
          [this.inputForm.executorDept, 'executorDept'],
          [this.inputForm.operatorDept, 'operatorDept'],
        ].map(([deptType, formField]) => {
          new QueryInfoService().getDept(deptType).then(dept => {
            this.$set(this.inputForm, `${formField}Name`, dept.data.data.deptName);
          }).catch(e => {
            console.log(e)
          })
        });
        // 获取字典
        const dicts = [
          ['mater_apply_type', 'applyType'],
          ['contract_state', 'states'],
          ['mater_audit_status', 'auditStatus'],
          ['contract_version', 'contractEdition'],
          ['contract_formation', 'formation'],
        ].map(([dictType, formField]) => {
          new QueryInfoService().getDicts(dictType).then(dict => {
            this.$set(this.inputForm, `${formField}Name`, dict.data.data.find(item => item.dictValue == this.inputForm[formField]).dictLabel);
          }).catch(e => {
            console.log(e)
          })
        });
      }).catch(e => {
        alert(e)
        console.log(e)
      })
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    // 数字转大写
    transferAmount(amount) {
      let tempAmount = ''
      if (amount !== '' && amount != null && amount !== '0') {
        let unit = '仟佰拾亿仟佰拾万仟佰拾元角分'
        let str = ''
        amount += '00'
        const point = amount.indexOf('.')
        if (point >= 0) {
          amount = amount.substring(0, point) + amount.substr(point + 1, 2)
        }
        unit = unit.substr(unit.length - amount.length)
        for (let i = 0; i < amount.length; i++) {
          str += '零壹贰叁肆伍陆柒捌玖'.charAt(amount.charAt(i)) + unit.charAt(i)
        }
        tempAmount = str.replace(/零(仟|佰|拾|角)/g, '零')
            .replace(/(零)+/g, '零')
            .replace(/零(万|亿|元)/g, '$1')
            .replace(/(亿)万|(拾)/g, '$1$2')
            .replace(/^元零?|零分/g, '')
            .replace(/元$/g, '圆') + '整';
      }
      return tempAmount;
    },
    // 保留小数
    fomatFloat(value, n) {
      var f = Math.round(value * Math.pow(10, n)) / Math.pow(10, n);
      var s = f.toString();
      var rs = s.indexOf('.');
      if (rs < 0) {
        s += '.';
      }
      for (var i = s.length - s.indexOf('.'); i <= n; i++) {
        s += "0";
      }
      return s;
    },
    // 查看物料台账
    view() {
      this.$router.push({
        path: 'materContract_detail',
        query: {
          id: this.inputForm.id,
        }
      })
    },
    submitTask() {
      if (this.isLoading) {return}
      this.isLoading = true
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.flowParam.approvalStatus = '2'; // 审核状态 [1:未审核;2:已审核-同意;3:已审核-不同意]")
      _this.flowParam.approvalOpinion = _this.auditForm.message;
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new auditService().materFlowConfirm(_this.flowParam).then((res) => {
          if(res.data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('操作成功');
            setTimeout(function () {
              _this.close()
            }, 800)
          } else {
            _this.$toast.clear();
            _this.$toast.fail(res.data.msg);
            setTimeout(function () {
              _this.close()
            }, 800)
          }
        })
      }).catch(() => {
        this.isLoading=false
      })
    },
    reject() {
      let _this = this
      _this.flowParam.approvalStatus = '3'; // 审核状态 [1:未审核;2:已审核-同意;3:已审核-不同意]")
      _this.flowParam.approvalOpinion = _this.auditForm.message;
      //审核不通过时，必须输入审核意见
      if (!_this.flowParam.approvalOpinion) {
        this.isMessage=true
        this.isLoading=false
        return
      }
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new auditService().materFlowConfirm(_this.flowParam).then((res) => {
          if(res.data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('操作成功');
            setTimeout(function () {
              _this.close()
            }, 800)
          } else {
            _this.$toast.clear();
            _this.$toast.fail(res.data.msg);
            setTimeout(function () {
              _this.close()
            }, 800)
          }
        })
      }).catch(() => {
        this.isLoading=false
      })
    }
  }
}
</script>
